import e from "semver/classes/semver";
import i from "semver/functions/gt";
var r,
  n = function () {
    try {
      var e = new URL(location.href);
      return !(!e || !e.searchParams) && !!e.searchParams.get("bridge_log");
    } catch (e) {
      return !1;
    }
  }(),
  t = function t() {
    for (var e = [], i = 0; i < arguments.length; i++) {
      e[i] = arguments[i];
    }
    n && console && console.warn.apply(console, e);
  },
  a = function a() {
    for (var e = [], i = 0; i < arguments.length; i++) {
      e[i] = arguments[i];
    }
    n && console && console.error.apply(console, e);
  },
  o = function o() {
    for (var e = [], i = 0; i < arguments.length; i++) {
      e[i] = arguments[i];
    }
    n && console && console.log.apply(console, e);
  };
function d() {
  try {
    var e = window.navigator.userAgent.toLowerCase().match(/app_type=(\d*)/);
    if (e && !Number.isNaN(Number(e[1]))) return Number(e[1]);
  } catch (e) {}
}
function c() {
  var e = d();
  try {
    var i = window.navigator.userAgent.toLowerCase();
    if (e === r.Driver) {
      var n = i.match(/shopee-food-driver\/(\S*)/);
      if (n && n[1] && n[1].length > 0) return n[1];
    }
    var t = i.match(/appver=(\d*)/);
    if (t && !Number.isNaN(Number(t[1]))) return Number(t[1]);
    var a = i.match(/version=(\d*)/);
    if (a && !Number.isNaN(Number(a[1]))) return Number(a[1]);
  } catch (e) {}
}
function p(r, n) {
  try {
    if ("number" == typeof r && "number" == typeof n) return function (e, i) {
      return e > i ? 1 : e < i ? -1 : 0;
    }(r, n);
    if ("string" == typeof r && "string" == typeof n) return function (r, n) {
      try {
        var t = new e(r),
          a = new e(n);
        return i(t, a) ? 1 : i(a, t) ? -1 : 0;
      } catch (e) {
        throw e;
      }
    }(r, n);
    throw new Error("Unsupport versions ".concat(r, ", ").concat(n));
  } catch (e) {
    throw e;
  }
}
!function (e) {
  e[e.Driver = 4] = "Driver";
}(r || (r = {}));
var s = void 0,
  u = void 0,
  l = void 0,
  w = void 0,
  g = void 0,
  f = void 0,
  v = void 0,
  h = void 0,
  b = void 0,
  m = void 0,
  y = void 0,
  B = void 0;
function A(e) {
  try {
    var i = d();
    return !!i && i === e;
  } catch (e) {
    return !1;
  }
}
function S() {
  if (null == s) {
    var e = window.navigator.userAgent.toLowerCase();
    s = e.indexOf("iphone") >= 0 || e.indexOf("ipad") >= 0 || e.indexOf("ipod") >= 0;
  }
  return s;
}
function _() {
  if (null == u) {
    var e = window.navigator.userAgent.toLowerCase();
    u = e.indexOf("android") > 0;
  }
  return u;
}
function O() {
  return B || (B = A(22)), B;
}
function J() {
  if (!f) {
    var e = window.navigator.userAgent.toLowerCase();
    f = !A(5) && !A(11) && (e.indexOf("airpay") >= 0 || e.indexOf("shopeepay") >= 0);
  }
  return f;
}
window.isIOS = S, window.isAndroid = _, window.isDirectDeliveryApp = O, window.isOldShopeePayApp = J;
var W = {
  major: 4,
  minor: 45,
  patch: 0
};
function C() {
  try {
    var e = window.navigator.userAgent.toLowerCase().match(/airpay\/(\d+)\.(\d+)\.(\d+) /);
    if (e && Array.isArray(e) && e.length >= 4) return {
      major: Number(e[1]),
      minor: Number(e[2]),
      patch: Number(e[3])
    };
  } catch (e) {
    a("getShopeePayVersion failed:", e);
  }
  return {
    major: 0,
    minor: 0,
    patch: 0
  };
}
function H(e, i) {
  return e.major > i.major ? 1 : e.major < i.major ? -1 : e.minor > i.minor ? 1 : e.minor < i.minor ? -1 : e.patch > i.patch ? 1 : e.patch < i.patch ? -1 : 0;
}
function N() {
  if (null == l) {
    var e = navigator.userAgent.indexOf("Shopee") >= 0,
      i = J(),
      r = H(C(), W),
      n = A(20);
    l = e || i && r >= 0 || n;
  }
  return l;
}
function x() {
  if (null == g) {
    var e = window.navigator.userAgent.toLowerCase();
    g = e.indexOf("shopeepay") >= 0 && A(5);
  }
  return g;
}
function V() {
  if (null == v) {
    var e = window.navigator.userAgent.toLowerCase();
    v = e.indexOf("driver") >= 0 || A(4);
  }
  return v;
}
function R() {
  return null == h && (h = A(11)), h;
}
function I() {
  return b || (window.navigator.userAgent.toLowerCase(), b = A(2)), b;
}
function E() {
  if (!m) {
    var e = window.navigator.userAgent.toLowerCase();
    m = -1 !== e.indexOf("mitra");
  }
  return m;
}
function P() {
  if (!y) {
    var e = window.navigator.userAgent.toLowerCase();
    y = -1 !== e.indexOf("nowmerchant");
  }
  return y;
}
function k() {
  return N() || V() || J() || x() || P() || I() || E() || R() || O();
}
window.isShopeeApp = N, window.isShopeeCompatApp = N, window.isRealShopeeApp = function () {
  if (null == w) {
    var e = window.navigator.userAgent.toLowerCase();
    w = e.indexOf("shopee") >= 0 && A(1);
  }
  return w;
}, window.isNewShopeePayApp = x, window.isShopeeFoodDriverApp = V, window.isShopeeFoodBuyerApp = R, window.isPartnerApp = I, window.isMitraApp = E, window.isMerchantApp = P, window.isApp = k;
var U,
  D = {
    isApp: k,
    isIOS: S,
    isAndroid: _,
    isShopeeApp: N,
    isShopeeFoodDriverApp: V,
    isShopeeFoodBuyerApp: R,
    isDirectDeliveryApp: O,
    isOldShopeePayApp: J,
    isPartnerApp: I,
    isMerchantApp: P,
    isShopeeRootUrl: function isShopeeRootUrl(e) {
      return !!e && "/" === e;
    },
    versionCompare: H,
    getShopeePayVersion: C,
    NewShopeePayVersion: W
  };
function M() {
  var e = "__WVJB_QUEUE_MESSAGE__";
  !function () {
    var i;
    if (window.inBeeShop = function () {
      return -1 != window.navigator.userAgent.toLowerCase().indexOf("beeshop");
    }, window.WebViewJavascriptBridge && window.WebViewJavascriptBridge._version >= 2) return;
    var r = [],
      n = [],
      a = {},
      d = {},
      c = 1;
    var p = {};
    function s(n, t) {
      if (!window.__appHasPendingCacheUpdate__) {
        if (t) {
          var a = "cb_" + c++ + "_" + Date.now();
          d[a] = t, n.callbackId = a;
        }
        -1 == window.navigator.userAgent.toLowerCase().indexOf("android") ? (o("shopee ios bridge message: ", JSON.stringify(n)), r.push(n), i.src = "wvjbscheme://" + e) : (o("shopee android bridge message: ", JSON.stringify(n)), window.gabridge.sendMsg(JSON.stringify(n)));
      }
    }
    function u(e) {
      if (o("_dispatchMessageFromObjC: ", e), !window.__appHasPendingCacheUpdate__) {
        try {
          var i = JSON.parse(e);
        } catch (e) {
          i = {};
          t("Bridge dispatch failed. err = " + e);
        }
        if (i.responseId) {
          if (!(r = d[i.responseId])) return;
          r(i.responseData), delete d[i.responseId];
        } else {
          var r;
          if (i.callbackId) {
            var n = i.callbackId;
            r = function r(e) {
              s({
                responseId: n,
                responseData: e
              });
            };
          }
          var c = window.WebViewJavascriptBridge._messageHandler;
          if (i.handlerName && (c = a[i.handlerName]), void 0 === c) return;
          for (var p in c) {
            if (c.hasOwnProperty(p)) try {
              c[p](i.data, r);
            } catch (e) {
              o("WebViewJavascriptBridge: WARNING: javascript handler threw.", i, e);
            }
          }
        }
      }
    }
    function l(e) {
      var i = !1;
      try {
        i = null != a[e];
      } catch (e) {
        i = !1;
      }
      return i ? "true" : "false";
    }
    function w(e) {
      window.gabridge && window.gabridge.onHasHandler && window.gabridge.onHasHandler(e, l(e));
    }
    window.WebViewJavascriptBridge = {
      init: function init(e) {
        if (window.WebViewJavascriptBridge._messageHandler) return t("WebViewJavascriptBridge.init called twice"), null;
        window.WebViewJavascriptBridge._messageHandler = [e];
        var i = n;
        n = null, setTimeout(function () {
          for (var e = 0; e < i.length; e++) {
            u(i[e]);
          }
        }, 0);
      },
      send: function send(e, i) {
        s({
          data: e
        }, i);
      },
      registerHandler: function registerHandler(e, i) {
        void 0 === a[e] && (a[e] = []), a[e].push(i), w(e);
      },
      unregisterHandler: function unregisterHandler(e, i) {
        if (i) {
          var r = a[e];
          if (r) {
            var n = r.indexOf(i);
            n >= 0 && r.splice(n, 1), 0 === r.length && (delete a[e], w(e));
          }
        }
      },
      callHandler: function callHandler(e, i, r) {
        for (var n in p) {
          if (p.hasOwnProperty(n)) try {
            p[n](e, i);
          } catch (e) {}
        }
        if ("fullScreenImage" == e && i) {
          var t = i.imageUrls;
          if (t && t.length) try {
            for (var a = 0; a < t.length; a++) {
              var o = t[a];
              "string" != typeof o || o.indexOf(window.ITEM_IMAGE_BASE_URL) < 0 || (t[a] = o.replace("/webp/", "/"));
            }
          } catch (e) {}
        }
        s({
          handlerName: e,
          data: i
        }, r);
      },
      hasHandler: l,
      hasHandlerCB: w,
      addHook: function addHook(e) {
        var i = e.toString();
        p[i] || (p[i] = e);
      },
      delHook: function delHook(e) {
        var i = e.toString();
        delete p[i];
      },
      appHasHandler: function appHasHandler(e) {
        return window.WebViewJavascriptBridgeiOSNativeAppConfig ? window.WebViewJavascriptBridgeiOSNativeAppConfig._appHandlers && window.WebViewJavascriptBridgeiOSNativeAppConfig._appHandlers.indexOf(e) >= 0 : window.WebViewJavascriptBridge._appHandlers && window.WebViewJavascriptBridge._appHandlers.indexOf(e) >= 0;
      },
      _fetchQueue: function _fetchQueue() {
        var e = JSON.stringify(r);
        return r = [], e;
      },
      _handleMessageFromObjC: function _handleMessageFromObjC(e) {
        n ? n.push(e) : u(e);
      },
      reset: function reset() {
        r = [], n = [], a = {}, d = {}, c = 1, window.WebViewJavascriptBridge._messageHandler = null;
      },
      _version: 2
    };
    var g = document;
    !function (r) {
      (i = r.createElement("iframe")).style.display = "none", i.src = "wvjbscheme://" + e, r.documentElement.appendChild(i);
    }(g);
    var f = g.createEvent("Events");
    f.initEvent("WebViewJavascriptBridgeReady"), f.bridge = window.WebViewJavascriptBridge, g.dispatchEvent(f);
    var v = null;
    var h = D.isShopeeApp() || D.isShopeeFoodDriverApp() || D.isShopeeFoodBuyerApp();
    D.isIOS() && h && setTimeout(function () {
      window.__gawindow__ || (v = setInterval(function () {
        (window.__gawindow__ || function (i, r) {
          try {
            var _a = D.isShopeeApp() || D.isShopeeFoodDriverApp() || D.isShopeeFoodBuyerApp();
            if (!(i || D.isIOS() && _a)) return !0;
            if (!window.document || !window.document.documentElement) return !1;
            var n = window.document.documentElement,
              t = document.createElement("iframe");
            return t.style.display = "none", t.src = r ? "wvjbscheme://" + e : "javascript:void(0)", n.appendChild(t), setTimeout(function () {
              n.removeChild(t);
            }, 500), !0;
          } catch (e) {
            return o("triggerIOSAppPageReInit_ex", e), !0;
          }
        }()) && (clearInterval(v), v = null);
      }, 300));
    }, 2e3);
  }(), window.connectWebViewJavascriptBridge = function (e) {
    var i = D.isShopeeApp() || D.isShopeeFoodDriverApp() || D.isShopeeFoodBuyerApp();
    i && (window.WebViewJavascriptBridge ? e(window.WebViewJavascriptBridge) : document.addEventListener("WebViewJavascriptBridgeReady", function () {
      i && e(window.WebViewJavascriptBridge);
    }, !1));
  };
}
function $() {
  D.isShopeeApp() || (window.BJBridgeReceiver = function () {
    var e = {};
    if (window.DEBUG_APPEAR && document.addEventListener("visibilitychange", function () {
      "visible" === document.visibilityState ? window.BJBridgeReceiver.triggerBridgeEvent("viewWillReappear") : window.BJBridgeReceiver.triggerBridgeEvent("viewDidDisappear");
    }), window.DEBUG_NAVBAR) {
      var i = document.createElement("div");
      i.id = "bridge-debug-navbar", i.setAttribute("style", "position:absolute;top:0;width:100%;height:64px;");
      var r = document.createElement("span");
      r.innerText = "back", r.setAttribute("style", "color:red;font-size:20px;float:left;line-height:64px;padding-left:15px;"), r.addEventListener("touchend", function () {
        window.BJBridgeReceiver.triggerBridgeEvent("didTapBack");
      }), i.appendChild(r), document.body.appendChild(i);
    }
    function n(i, r) {
      var n = i.callbackId;
      n in e && e[n](r);
    }
    var o = {
      onEventCallback: [],
      didTapBack: [],
      tabShow: [],
      viewWillReappear: [],
      viewDidDisappear: []
    };
    function d(e, i) {
      try {
        return new URL(i, e).href;
      } catch (e) {}
      var r = function (e) {
        var i = document.createElement("A");
        return i.href = e, i;
      }(e);
      if (i.startsWith("http://") || i.startsWith("https://")) return i;
      var n = i;
      return i.startsWith("/") || (n = r.pathname.substr(0, r.pathname.lastIndexOf("/")) + "/" + i), r.origin + n;
    }
    function c(e, i) {
      window.MALL_HOST_ROOT_URL && 0 == e.indexOf("/") && (e = window.MALL_HOST_ROOT_URL + e), i ? window.open(e) : location.href = e;
    }
    function p(e) {
      var i = e.title;
      i && (document.title = i);
    }
    var s = 0,
      u = 1,
      l = [{
        regex: "^home$",
        type: s,
        path: "/"
      }, {
        regex: "^me$",
        type: s,
        path: "/me/"
      }, {
        regex: "^cart$",
        type: s,
        path: "/buyer/cart/"
      }, {
        regex: "^checkout$",
        type: s,
        path: "/buyer/w/checkout/confirmation/"
      }, {
        regex: "^paid$",
        type: s,
        path: "/me/?page=all"
      }, {
        regex: "^unpaid$",
        type: s,
        path: "/me/"
      }, {
        regex: "^cancelled$",
        type: s,
        path: "/me/"
      }, {
        regex: "^purchases?tab=paid$",
        type: s,
        path: "/me/"
      }, {
        regex: "^/user/groups/$",
        type: s,
        path: "/user/groups/"
      }, {
        regex: "^/user/groups/\\d+$",
        type: u
      }],
      w = [{
        regex: "^home$",
        type: s,
        path: "/"
      }, {
        regex: "^me$",
        type: s,
        path: "/me/"
      }, {
        regex: "^cart$",
        type: s,
        path: "/cart/"
      }, {
        regex: "^checkout$",
        type: s,
        path: "/checkout/"
      }, {
        regex: "^paid$",
        type: s,
        path: "/user/purchase/list/?type=7"
      }, {
        regex: "^unpaid$",
        type: s,
        path: "/user/purchase/list/?type=9"
      }, {
        regex: "^cancelled$",
        type: s,
        path: "/user/purchase/list/?type=4"
      }, {
        regex: "^mycard$",
        type: s,
        path: "/user/account/payment"
      }, {
        regex: "^purchases?tab=paid$",
        type: s,
        path: "/me/"
      }, {
        regex: "^/user/groups/$",
        type: s,
        path: "/user/groups/"
      }, {
        regex: "^/user/groups/\\d+$",
        type: u
      }],
      g = [{
        regex: "^/order/success/\\d+$",
        type: u
      }, {
        regex: "^paid$",
        type: s,
        path: "/user/purchase?type=7"
      }, {
        regex: "^unpaid$",
        type: s,
        path: "/user/purchase"
      }];
    function f(e, i) {
      for (var r = 0; r < i.length; r++) {
        var n = i[r],
          t = n.regex;
        if (e.match(t)) switch (n.type) {
          case s:
            return n.path;
          case u:
            return e;
          default:
            return null;
        }
      }
      return null;
    }
    var v = {
      popWebView: function popWebView() {
        window.history.back(), setTimeout(function () {
          null != window.opener && window.opener != window && window.close();
        }, 300);
      },
      navigate: function navigate(e) {
        var i = e.url;
        "_blank" == e.target ? c(i, !0) : c(i);
      },
      configureNavBarTitle: p,
      configurePage: function configurePage(e) {
        e.navbar && e.navbar.title && p({
          title: e.navbar.title
        });
      },
      save: function save(e) {
        var i = e.key,
          r = e.data,
          t = e.persist;
        if (i && r) try {
          return window.sessionStorage.setItem(i, r), t && window.localStorage.setItem(i, r), void n(e, {
            status: 1
          });
        } catch (e) {
          a("bridge CMD save error: ", e);
        }
        n(e, {
          status: 0
        });
      },
      load: function load(e) {
        var i,
          r = e.key;
        if (r) try {
          (i = window.sessionStorage.getItem(r)) || (i = window.localStorage.getItem(r));
        } catch (e) {
          a("bridge CMD load error: ", e);
        }
        n(e, {
          data: i
        });
      },
      jump: function jump(e) {
        var i = e.path.indexOf("?"),
          r = e.path,
          n = "";
        i > -1 && (r = e.path.slice(0, -1), n = pathArr[1]), (r = e.pcmallBaseUrl ? d(e.pcmallBaseUrl, function (e) {
          return f(e, w);
        }(r) || r) : e.liteBaseUrl ? d(e.liteBaseUrl, function (e) {
          return f(e, g);
        }(r) || r) : function (e) {
          return f(e, l);
        }(r)) ? c(r + n) : a("Unsupported AppRoute on web - {0}. Refer to UrlByAppRoute in BJBridgeReceiver.js for supported routes.".f(e.path));
      },
      getAppInfo: function getAppInfo(e) {
        var i,
          r,
          t = {
            deviceID: null
          };
        t.deviceFingerprint = (i = new RegExp("(?:^|;+|\\s+)" + "SPC_F" + "=([^;]*)"), r = "", document && (r = document.cookie.match(i)), (r ? r[1] : "") || null), t.BCAXOWidgetDeviceID = "WEB", n(e, t);
      },
      login: function login(e) {
        var i;
        if (e) {
          if (1 === e.redirectTab) i = "/buyer/login/";else i = "/buyer/login/signup/";
        } else i = "/buyer/login/signup/";
        c(i);
      },
      share: function share(e) {
        n(e, e);
      },
      copyTextToClipboard: function copyTextToClipboard(e) {
        var i = e.text;
        if (window.clipboardData && window.clipboardData.setData) return clipboardData.setData("Text", i);
        if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
          var r = document.createElement("textarea");
          r.textContent = i, r.style.position = "fixed", document.body.appendChild(r), r.select();
          try {
            document.execCommand("copy") ? n(e) : n(e, "error");
          } catch (i) {
            return t("Copy to clipboard failed.", i), n(e, "error"), !1;
          } finally {
            document.body.removeChild(r);
          }
        }
      }
    };
    return {
      callHandler: function callHandler(i, r, n) {
        if (v[i]) {
          if (n) var a = function (i, r) {
            var n = i + Date.now();
            return e[n] = function (i) {
              r(i), delete e[n];
            }, n;
          }(i, n);
          r.callbackId = a, v[i](r);
        } else t("web Unsupported CMD - " + i);
      },
      registerHandler: function registerHandler(e, i) {
        var r, n;
        "function" == typeof i && (n = i, (r = e) in o && o[r].push(n));
      },
      unRegisterHandler: function unRegisterHandler(e, i) {
        if (e in o) if (i) {
          var r = o[e].indexOf(i);
          r > -1 && o[e].splice(r, 1);
        } else o[e] = [];
      },
      callCallback: n,
      triggerBridgeEvent: function triggerBridgeEvent(e, i) {
        var r = o[e];
        r ? r.forEach(function (e) {
          "function" == typeof e && e(i);
        }) : (t("Unsupported Bridge Event - " + e), t(i));
      }
    };
  }());
}
function T() {
  M(), $();
}
window.BJUtil = {
  navigate: function navigate(e, i, r, n, t) {
    var a = n || {};
    i && (a.inCurrentPage = !0), t && (a.popHistory = !0), r && (a.target = "_blank"), e.startsWith("//") ? a.url = location.protocol + e : e.startsWith("/") ? a.url = location.origin + e : a.url = e, bridgeCallHandler("navigate", a, function (e) {});
  }
}, window.bridgeInit = (U = !1, function (e) {
  e && "function" == typeof e && "function" == typeof window.connectWebViewJavascriptBridge ? connectWebViewJavascriptBridge(function (i) {
    U || (i.init(function () {}), U = !0), e(i);
  }) : e();
}), window.bridgeCallHandler = function (e, i, r) {
  var n,
    t = window.WebViewJavascriptBridge,
    a = window.BJBridgeReceiver;
  if (i = i || {}, "navigate" == e) {
    if (window.RNUtil && window.RNUtil.jumpToReactNativeIfExists(i.url, i.popSelf || i.popHistory || i.inCurrentPage)) return;
    if (D.isShopeeApp() && D.isShopeeRootUrl(i.url)) return void bridgeCallHandler("jump", {
      path: "home"
    }, null);
    if (i.popHistory) return void window.location.replace(i.url);
    if (i.inCurrentPage) return void (window.location.href = i.url);
  } else if ("load" == e) {
    if (D.isShopeeApp() && D.isAndroid()) {
      var d = (n = !1, function () {
          n || (n = !0, bridgeUnRegisterHandler("viewWillReappear", c), r(void 0));
        }),
        c = function c() {
          t.callHandler(e, i, function (e) {
            d(e);
          });
        };
      return c(), void bridgeRegisterHandler("viewWillReappear", c);
    }
  } else "popWebView" === e ? o("popWebView " + location.href + " with data:" + i.data) : "navigateRawUrl" === e && (e = "navigate");
  o("bridge", t), t ? t.callHandler(e, i, r) : a && a.callHandler(e, i, r);
}, window.bridgeRegisterHandler = function (e, i) {
  var r = window.WebViewJavascriptBridge,
    n = window.BJBridgeReceiver;
  r && "registerHandler" in r ? r.registerHandler(e, i) : n && "registerHandler" in n && n.registerHandler(e, i);
}, window.bridgeUnRegisterHandler = function (e, i) {
  var r = window.WebViewJavascriptBridge,
    n = window.BJBridgeReceiver;
  r && "unregisterHandler" in r ? r.unregisterHandler(e, i) : n && "unRegisterHandler" in n && n.unRegisterHandler(e);
};
var j = function j() {
  var e = D.isOldShopeePayApp() || D.isShopeeFoodDriverApp() || D.isShopeeFoodBuyerApp() || D.isMerchantApp();
  var i, r, n;
  e ? D.isIOS() ? function () {
    if (!window.WebViewJavascriptBridge || !Object.prototype.hasOwnProperty.call(window.WebViewJavascriptBridge, "iOSFinishInitialization")) {
      var e,
        i = [],
        r = [],
        n = {},
        d = "__WVJB_QUEUE_MESSAGE__",
        c = {},
        p = 1;
      window.bridge = {}, window.bridge.call = function (e, i, r) {
        i && (i = i.replace(/\r\n|\r|\n|\t/g, " "));
        try {
          i = JSON.parse(i) || {};
        } catch (e) {}
        "pageBack" === e && window.__pageBack && window.__pageBack(i);
      }, window.WebViewJavascriptBridge = {
        iOSFinishInitialization: !0,
        init: function init(e) {
          if (window.WebViewJavascriptBridge._messageHandler) return t("WebViewJavascriptBridge.init called twice"), null;
          window.WebViewJavascriptBridge._messageHandler = [e];
          var i = r;
          r = null;
          for (var n = 0; n < i.length; n++) {
            u(i[n]);
          }
        },
        send: function send(e, i) {
          s({
            data: e
          }, i);
        },
        registerHandler: function registerHandler(e, i) {
          void 0 === n[e] ? n[e] = [i] : n[e].push(i);
        },
        callHandler: function callHandler(e, i, r) {
          s({
            handlerName: e,
            data: i
          }, r);
        },
        _fetchQueue: function _fetchQueue() {
          var e = JSON.stringify(i);
          return i = [], e;
        },
        _handleMessageFromObjC: function _handleMessageFromObjC(e) {
          r ? r.push(e) : u(e);
        }
      }, function (i) {
        try {
          (e = i.createElement("iframe")).style.display = "none", e.src = "wvjbscheme://" + d, i.documentElement.appendChild(e);
        } catch (e) {
          a("_createQueueReadyIframe failed:", e);
        }
      }(document);
    }
    function s(r, n) {
      if (n) {
        var t = "cb_" + p++ + "_" + new Date().getTime();
        c[t] = n, r.callbackId = t;
      }
      o("iOS: message=".concat(JSON.stringify(r))), i.push(r), e.src = "wvjbscheme://" + d;
    }
    function u(e) {
      setTimeout(function () {
        o("ios: ".concat(e));
        var i = JSON.parse(e);
        if (i.responseId) {
          if (!(r = c[i.responseId])) return;
          r(i.responseData), delete c[i.responseId];
        } else {
          var r;
          if (i.callbackId) {
            var t = i.callbackId;
            r = function r(e) {
              s({
                responseId: t,
                responseData: e
              });
            };
          }
          var a = window.WebViewJavascriptBridge._messageHandler;
          if (i.handlerName && (a = n[i.handlerName]), void 0 === a) return;
          for (var d = 0; d < a.length; d++) {
            try {
              a[d](i.data, r);
            } catch (e) {
              o("WebViewJavascriptBridge: WARNING: javascript handler threw.", i, e);
            }
          }
        }
      }, 0);
    }
  }() : (i = 1, r = {}, n = {}, window.bridge || (window.bridge = {}), window.bridge.onReceive = function (e, i) {
    var a = {};
    try {
      a = JSON.parse(i), o("Android: result=".concat(i, "|callbackId=").concat(e, "|href=").concat(location.href)), o("Android: callbacks=".concat(JSON.stringify(r)));
    } catch (e) {
      t("Android: JSON.parse data from client failed: ", e);
    }
    if (e) r[e](a), delete r[e];else if (a.handlerName) {
      var d = n[a.handlerName];
      if (void 0 === d) return;
      for (var c = 0; c < d.length; c++) {
        try {
          delete a.handlerName, d[c](a);
        } catch (e) {
          o("WebViewJavascriptBridge: WARNING: javascript handler threw.", a, e);
        }
      }
    }
  }, window.bridge.call = function (e, i, t) {
    i && (i = i.replace(/\r\n|\r|\n|\t/g, " "));
    try {
      i = JSON.parse(i) || {};
    } catch (e) {}
    switch (e) {
      case "openView":
        if (t) {
          r[t](i), delete r[t];
          break;
        }
      case "pageBack":
        window.__pageBack && window.__pageBack(i);
        break;
      default:
        var a = n[e];
        if (void 0 === a) return;
        for (var d = 0; d < a.length; d++) {
          try {
            a[d](i);
          } catch (e) {
            o("WebViewJavascriptBridge: WARNING: javascript handler threw.", e);
          }
        }
    }
  }, window.WebViewJavascriptBridge = {
    init: function init() {},
    _handleMessageFromObjC: function _handleMessageFromObjC() {},
    callHandler: function callHandler(e, n, t) {
      var a = "cb_" + i++ + "_" + new Date().getTime();
      if (r[a] = t, window.gabridge && !D.isOldShopeePayApp()) {
        var _i = JSON.stringify({
          handlerName: e,
          data: n,
          callbackId: a
        });
        o("Android gabridge.sendMsg: ".concat(_i)), window.gabridge.sendMsg(_i);
      } else {
        var d = JSON.stringify(n);
        o("Android bridge.send: handleName=".concat(e, ", data=").concat(d)), window.bridge.send(e, d, a);
      }
    },
    hasHandler: function hasHandler(e) {
      return window.bridge.hasHandler(e);
    },
    registerHandler: function registerHandler(e, i) {
      void 0 === n[e] ? n[e] = [i] : n[e].push(i);
    },
    hasRegisteredHandler: function hasRegisteredHandler(e) {
      var i = !1;
      try {
        i = null != n[e];
      } catch (e) {}
      return i;
    }
  }) : window.WebViewJavascriptBridge = null, window.connectWebViewJavascriptBridge = function (i) {
    e && (o("window.WebViewJavascriptBridge:", window.WebViewJavascriptBridge), window.WebViewJavascriptBridge && Object.prototype.hasOwnProperty.call(window.WebViewJavascriptBridge, "_handleMessageFromObjC") ? i(window.WebViewJavascriptBridge) : document.addEventListener("WebViewJavascriptBridgeReady", function () {
      i(window.WebViewJavascriptBridge);
    }, !1));
  };
  var d = document,
    c = d.createEvent("Events");
  c.initEvent("WebViewJavascriptBridgeReady"), c.bridge = window.WebViewJavascriptBridge, d.dispatchEvent(c);
};
var L,
  F,
  G = -999,
  Q = -996,
  z = -993,
  q = ((L = {})[G] = "bridge call timeout", L[Q] = "bridge call failed", L[z] = "bridge no support", L),
  X = new (function () {
    function e() {
      this.inited = !1, this.handlerMap = new Map();
    }
    return e.prototype.ready = function () {
      var e = this;
      return o("bridge.ready:", this.inited), this.inited ? Promise.resolve(!0) : new Promise(function (i, r) {
        window.bridgeInit(function (n) {
          o("window.bridgeInit callback:", n), e.inited = !!n, e.inited ? i(!0) : r(!1);
        });
      });
    }, e.prototype.callBridge = function (e, i) {
      this.innerCall(e, i).then(function (e) {
        o("bridge.callBridge res:", e);
      }).catch(function (e) {
        o("bridge.callBridge err:", e);
      });
    }, e.prototype.callBridgePromise = function (e, i, r) {
      return r && r > 0 ? Promise.race([this.innerCall(e, i), new Promise(function (e, i) {
        setTimeout(function () {
          i({
            code: G,
            data: {},
            msg: q[G]
          });
        }, r);
      })]) : this.innerCall(e, i);
    }, e.prototype.on = function (e, i) {
      var r = this;
      this.ready().then(function () {
        var n = function n(e) {
          i({
            code: 0,
            data: e
          });
        };
        r.handlerMap.set(i, n), "bridgeRegisterHandler" in window && window.bridgeRegisterHandler(e, n);
      }).catch(function () {});
    }, e.prototype.off = function (e, i) {
      var r = this;
      this.ready().then(function () {
        var n = r.handlerMap.get(i);
        n && "bridgeUnRegisterHandler" in window && window.bridgeUnRegisterHandler(e, n);
      }).catch(function () {});
    }, e.prototype.innerCall = function (e, i) {
      var r = this;
      return new Promise(function (n, t) {
        r.ready().then(function () {
          try {
            o("bridge.innerCall before call bridgeCallHandler"), window.bridgeCallHandler(e, i, function (e) {
              o("bridge.innerCall bridgeCallHandler result:", e), n({
                code: 0,
                data: e
              });
            });
          } catch (e) {
            a("bridge.innerCall call bridgeCallHandler failed"), t({
              code: Q,
              data: e,
              msg: q[Q]
            });
          }
        }).catch(function (e) {
          o("bridge.innerCall catch:", e), t({
            code: Q,
            data: e,
            msg: q[Q]
          });
        });
      });
    }, e;
  }())();
!function (e) {
  e[e.Unknown = 0] = "Unknown", e[e.Menu = 1] = "Menu", e[e.Url = 2] = "Url", e[e.Function = 3] = "Function", e[e.Channel = 4] = "Channel", e[e.ChennelType = 5] = "ChennelType", e[e.WebUI = 6] = "WebUI";
}(F || (F = {}));
var K = D.isShopeeFoodBuyerApp(),
  Y = D.isShopeeFoodDriverApp(),
  Z = D.isMerchantApp(),
  ee = D.isOldShopeePayApp(),
  ie = D.isShopeeApp(),
  re = {
    on: function on(e, i) {
      (ie || ee || Y || K) && X.on(e, i);
    },
    off: function off(e, i) {
      (ie || ee || Y || K) && X.off(e, i);
    },
    callBridge: function callBridge(e, i, r) {
      if (void 0 === r && (r = !0), r && !window.supportWebBridge()) return Promise.reject({
        code: z,
        data: {},
        msg: q[z]
      });
      if (ie || K || Z) return X.callBridgePromise(e, i);
      if (ee) {
        var n = function (e, i) {
          var r = {
              configurePage: {
                name: "setPageTitle",
                data: function data() {
                  var e,
                    r = null === (e = null == i ? void 0 : i.navbar) || void 0 === e ? void 0 : e.title;
                  return r ? {
                    title: r
                  } : {};
                }
              },
              popWebView: {
                name: "exit",
                data: function data() {
                  return {};
                }
              },
              navigate: {
                name: "openView",
                data: function data() {
                  var e = null == i ? void 0 : i.url;
                  return {
                    targetType: F.Url,
                    target: {
                      type: F.Url,
                      dataString: e
                    }
                  };
                }
              },
              showToast: {
                name: "showToastOrHud",
                data: function data() {
                  var e, r;
                  return {
                    msg: null === (e = null == i ? void 0 : i.toast) || void 0 === e ? void 0 : e.message,
                    msg_nature: {
                      success: 0,
                      failure: 1
                    }[null === (r = null == i ? void 0 : i.toast) || void 0 === r ? void 0 : r.iconType],
                    duration: 2e3
                  };
                }
              }
            },
            n = r[e];
          return n ? {
            name: n.name,
            data: n.data()
          } : null;
        }(e, i);
        if (n) return X.callBridgePromise(n.name, n.data);
      }
      if (Y) {
        n = function (e, i) {
          return ["configurePage", "openLivechat", "navigate", "openExternalLink", "showToast", "navigateAppRL", "liveChatGetToken"].includes(e) ? {
            name: e,
            data: i
          } : null;
        }(e, i);
        if (n) return X.callBridgePromise(n.name, n.data);
      }
      return Promise.reject({
        code: z,
        data: {},
        msg: q[z]
      });
    }
  };
if (window.supportWebBridge = function () {
  if (D.isAndroid()) return !!(window.gabridge && "sendMsg" in window.gabridge || window.bridge && "send" in window.bridge);
  if (D.isIOS()) {
    if (D.isShopeeApp() || D.isShopeeFoodDriverApp() || D.isShopeeFoodBuyerApp() || D.isMerchantApp()) return o("window.WebViewJavascriptBridgeiOSNativeAppConfig:", window.WebViewJavascriptBridgeiOSNativeAppConfig), !!window.WebViewJavascriptBridgeiOSNativeAppConfig;
    if (D.isOldShopeePayApp()) return !0;
  }
  return !1;
}, D.isApp()) try {
  if (o("start init bridge"), D.isMerchantApp()) try {
    o("Merchant App using shopee bridge"), j();
  } catch (e) {
    o("Merchant App does not support bridge");
  } else if (D.isOldShopeePayApp()) {
    D.versionCompare(D.getShopeePayVersion(), D.NewShopeePayVersion) >= 0 ? (o("ShopeePay App using shopee bridge"), T()) : (o("ShopeePay App using shopeepay custom bridge"), j());
  } else o("using shopee bridge"), T();
} catch (e) {
  a("app-webbridge init bridge failed:", e);
}
export { p as compareAppVersion, re as default, d as getAppType, c as getAppVersion };